const moment = require('moment');

let _utils = {

    downloadFile(fileData, fileName) {
        var csv = fileData
        var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

        if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, fileName + ".csv")
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) {
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", fileName + ".csv");
                link.style = "visibility:hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    },


    downloadZipFile(fileData, fileName) {
        var csv = fileData
        var blob = new Blob([csv], { type: "application/zip" });

        if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, fileName + ".zip")
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) {
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", fileName + ".zip");
                link.style = "visibility:hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }

    },

    downloadReport(fileData, fileName, fileType) {

        var csv = fileData
        var blob = new Blob([csv]);

        if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, fileName + '.' + fileType)
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) {
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", fileName + '.' + fileType);
                link.style = "visibility:hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }

    },

    getBlobFullURL(fileName) {
        if (!fileName)
            return null;

        const APP_BLOB_ROOT = window._env_ != null ? window._env_.APP_BLOB_ROOT : "";
        return APP_BLOB_ROOT + fileName;
    },

    getFileNameOfBlobURL(fileURL) {
        const APP_BLOB_ROOT = window._env_ != null ? window._env_.APP_BLOB_ROOT : "";
        let tempString = fileURL;
        return tempString.replace(APP_BLOB_ROOT, '');;
    },

    groupJSONArrayOfObjectsByKey(list, key) {
        return list.reduce(function (rv, x) {
            console.log("T: ",key);
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    },

    convertToIndianDateFormat(dateStr) {
        // Parse the date string to a Date object
        const date = new Date(dateStr);

        // Get the individual components
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();

        // Construct the formatted date string
        const formattedDate = `${day}/${month}/${year}`;
        return formattedDate;
    },

    formatDateAndTime(timestamp) {
        const date = new Date(timestamp);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const year = date.getFullYear();

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';

        hours = hours % 12;
        hours = hours ? hours : 12; // The hour '0' should be '12'
        const formattedHours = String(hours).padStart(2, '0');

        return `${day}/${month}/${year} ${formattedHours}:${minutes}:${seconds} ${ampm}`;
    },

    // Hall Ticket PDF Filename Fix: shared by both the candidate's own Hall Ticket screen
    // (ExamCard2_new.jsx) and the admin "View Hall Ticket" lookup screen (ViewExamCardByAdmin_new.jsx)
    // so both downloads follow the exact same convention from one implementation, not two that could
    // drift apart. Takes the same studentPersonalModel shape both screens already fetch (no new API
    // call). Deliberately excludes Aadhaar/mobile/password — only Form Number, candidate name, and
    // Roll Number (the same identifiers already shown on the ticket itself) go into the filename.
    buildHallTicketFileName(model) {
        model = model || {};
        const sanitize = (value) => String(value || '').trim().replace(/[^a-zA-Z0-9]+/g, '_').replace(/^_+|_+$/g, '');
        const formNumber = sanitize(model.Form_Number) || 'Unknown';
        const candidateName = sanitize([model.First_Name, model.Middle_Name, model.Last_Name].filter(Boolean).join('_')) || 'Candidate';
        const rollNumber = sanitize(model.Roll_Number);
        const parts = ['Hall_Ticket', formNumber, candidateName];
        if (rollNumber) {
            parts.push(rollNumber);
        }
        return parts.join('_') + '.pdf';
    },

    // Recruitment Candidate-List Publication Modernization phase. `stage` is 'First' or 'Final';
    // `postName` is optional (an "all posts" generation omits it rather than emitting an empty segment).
    buildEligibleCandidateListFileName(stage, postName, generatedAt) {
        const sanitize = (value) => String(value || '').trim().replace(/[^a-zA-Z0-9]+/g, '_').replace(/^_+|_+$/g, '');
        // PDF Filename Closure phase: the target convention's own example date segment keeps its
        // hyphens (25-Aug-2026, not 25_Aug_2026) — a plain `sanitize()` pass would collapse them to
        // underscores like everything else. Hyphens are filesystem-safe and Content-Disposition-safe,
        // and this value is always machine-built from moment's own DD-MMM-YYYY format (never raw
        // user input), so preserving them here carries no injection risk.
        const sanitizeDate = (value) => String(value || '').trim().replace(/[^a-zA-Z0-9-]+/g, '_').replace(/^_+|_+$/g, '');
        const stageSegment = sanitize(stage) || 'Eligible';
        const postSegment = sanitize(postName);
        const dateSegment = sanitizeDate(moment(generatedAt || new Date()).format('DD-MMM-YYYY'));
        const parts = [stageSegment + '_Eligible_Candidates_List'];
        if (postSegment) {
            parts.push(postSegment);
        }
        parts.push(dateSegment);
        return parts.join('_') + '.pdf';
    },

    // Final Result, Selected/Waiting Publication & Appointment Letter Closure phase — mirrors
    // buildEligibleCandidateListFileName's exact convention/sanitization for the new Selected/Waiting
    // Roll Number PDF (meaningful filename, not GUID-only).
    buildSelectedWaitingListFileName(postName, generatedAt) {
        const sanitize = (value) => String(value || '').trim().replace(/[^a-zA-Z0-9]+/g, '_').replace(/^_+|_+$/g, '');
        const sanitizeDate = (value) => String(value || '').trim().replace(/[^a-zA-Z0-9-]+/g, '_').replace(/^_+|_+$/g, '');
        const postSegment = sanitize(postName);
        const dateSegment = sanitizeDate(moment(generatedAt || new Date()).format('DD-MMM-YYYY'));
        const parts = ['Selected_Waiting_List'];
        if (postSegment) {
            parts.push(postSegment);
        }
        parts.push(dateSegment);
        return parts.join('_') + '.pdf';
    },

    // Phase C (Interview Call Letter) — mirrors buildHallTicketFileName's own convention exactly (same
    // sanitizer, same "Candidate"/"Unknown" fallbacks) so a candidate never downloads a generic
    // "Candidate_InterviewCallLetter.pdf". `model` is the CallLetterViewModel returned by
    // GetCallLetterForCandidate — ApplicationNumber/CandidateName/RollNumber, all already server-derived.
    buildInterviewCallLetterFileName(model) {
        model = model || {};
        const sanitize = (value) => String(value || '').trim().replace(/[^a-zA-Z0-9]+/g, '_').replace(/^_+|_+$/g, '');
        const applicationId = sanitize(model.ApplicationNumber) || 'Unknown';
        const candidateName = sanitize(model.CandidateName) || 'Candidate';
        const rollNumber = sanitize(model.RollNumber);
        const parts = ['Interview_Call_Letter', applicationId, candidateName];
        if (rollNumber) {
            parts.push(rollNumber);
        }
        return parts.join('_') + '.pdf';
    },

    // Branding/UI Artifact Forensic Audit phase: StudentAppointmentLetter.jsx previously saved every
    // candidate's download as the same generic "Student_Appointment_Letter.pdf" — mirrors
    // buildInterviewCallLetterFileName's exact convention so this download is meaningful/candidate-
    // specific too, consistent with every other letter/document this portal generates.
    buildAppointmentLetterFileName(model) {
        model = model || {};
        const sanitize = (value) => String(value || '').trim().replace(/[^a-zA-Z0-9]+/g, '_').replace(/^_+|_+$/g, '');
        const applicationId = sanitize(model.ApplicationId) || 'Unknown';
        const candidateName = sanitize(model.CandidateName) || 'Candidate';
        const rollNumber = sanitize(model.RollNumber);
        const parts = ['Appointment_Letter', applicationId, candidateName];
        if (rollNumber) {
            parts.push(rollNumber);
        }
        return parts.join('_') + '.pdf';
    },

    formatTimeAttendanceSheetData(timeRange){
        if (timeRange.includes('_TO_')) {
            // Replace `_TO_` with a delimiter, then split the string
            const times = timeRange.replace('_TO_', ' ').split(' ');
        
            // Convert each time to a readable format
            const formattedTimes = times.map(time => 
                moment(time, ['hh_A', 'hh_mm_A']).format('hh:mmA')
            );
        
            // Join the formatted times with "to"
            return `${formattedTimes[0]} to ${formattedTimes[1]}`;
        }
        else{
            return timeRange;
        }
    }
}

export default _utils;